// @flow

import { type Address } from './types';
import { isComplete } from './is-complete';
import { isEmpty } from './is-empty';

export function isPartial(address: ?Address): boolean {
  return !isComplete(address) && !isEmpty(address);
}
